import { render, staticRenderFns } from "./notificationAlert.vue?vue&type=template&id=3aa4ae81&"
import script from "./notificationAlert.vue?vue&type=script&lang=js&"
export * from "./notificationAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports